import pako from 'pako';

/**
 * Inflates the specified buffer (raw deflate) and returns it as a UTF-8 encoded string.
 * Uses pako so it runs in both Node and browser/worker (no Node zlib/assert).
 * @param arrayBuffer Buffer to inflate.
 */
export const inflateArrayBuffer = (arrayBuffer: ArrayBuffer): string => {
  if (!(arrayBuffer instanceof ArrayBuffer)) {
    throw new Error(`Buffer to inflate must be an ArrayBuffer.`);
  }
  const inflated = pako.inflate(new Uint8Array(arrayBuffer));
  return new TextDecoder().decode(inflated);
};

/**
 * Gzips the data with the browser's native CompressionStream, which compresses outside the
 * JavaScript main thread.
 * @param data Data to compress.
 */
export const gzip = async (data: ArrayBuffer): Promise<Blob> => {
  const stream = new Response(data).body!.pipeThrough(new CompressionStream('gzip'));
  return await new Response(stream).blob();
};
